module.exports = __webpack_public_path__ + "static/media/portrait.e91bdfbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/portrait.png
// module id = 657
// module chunks = 0